import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.addEventListener('DOMContentLoaded', (event) => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    createRoot(rootElement).render(
        <App />
    );
  }
});

reportWebVitals();